<template>
  <div class="register-container">
    <el-form class="register-form" autoComplete="on" :model="registerForm" :rules="registerRules" ref="registerForm"
             label-position="left">
      <h3 class="title">科乐支付平台</h3>
      <el-form-item prop="username">
        <span class="svg-container svg-container_register">
          <font-awesome-icon icon="user"></font-awesome-icon>
        </span>
        <el-input name="username" type="text" v-model="registerForm.username" autoComplete="off"
                  placeholder="请输入手机号"/>
      </el-form-item>
      <el-form-item prop="verificationCode" class="code">
        <span class="svg-container svg-container_register">
          <font-awesome-icon icon="envelope-open"></font-awesome-icon>
        </span>
        <el-input name="inputCode" type="text" v-model="registerForm.verificationCode"
                  autoComplete="off"
                  placeholder="请输入验证码"></el-input>
      </el-form-item>
      <el-button :disabled="isDisable"
                 class="get-code"
                 @click.prevent="sendSmsCode('registerForm')">{{getCode_btn}}</el-button>
      <el-form-item prop="password">
        <span class="svg-container svg-container_register">
          <font-awesome-icon icon="lock"></font-awesome-icon>
        </span>
        <el-input name="password" :type="pwdType" v-model="registerForm.password"
                  autoComplete="off"
                  placeholder="请输入密码"></el-input>
        <span class="show-pwd" @click="showPwd">
          <font-awesome-icon icon="eye"></font-awesome-icon>
        </span>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" native-type="submit" class="sign-up" :loading="loading" @click.native.prevent="handleRegister">
          修改密码
        </el-button>
      </el-form-item>
      <div class="tips">
        <router-link to="/login">已有账号,返回登录</router-link>
      </div>
    </el-form>
  </div>
</template>

<script>
  import {isvalidPassword, isvalidPhoneNumber} from '@/utils/validate'
  import {getModifyPasswordCode, postModifyPasswordCode, changePassword } from '@/api/users'
  export default {
    name: "changePassword",
    data() {
      const validatePhoneNo = (rule, value, callback) => {
        if (value.indexOf(' ') !== -1) {
          callback(new Error('手机号不能有空格'))
        } else if (!isvalidPhoneNumber(value)) {
          callback(new Error('手机号格式不正确'))
        } else {
          callback()
        }
      }
      const validatePass = (rule, value, callback) => {
        if (!value || value.indexOf(' ') !== -1) {
          callback(new Error('密码不能为空'))
        } else if (!isvalidPassword(value)) {
          callback(new Error('密码至少包含一个大写、小写字母和数字,长度在[8-20]之间'))
        } else {
          callback()
        }
      }
      const validateCode = (rule, value, callback) => {
        if (value && value.trim().length > 0) {
          getModifyPasswordCode({
            phoneNumber: this.registerForm.username,
            code: this.registerForm.verificationCode,
          }).then(result => {
            if (!result || !result.code || result.code !== value) {
              callback(new Error('验证码错误或者已失效'))
            } else {
              callback()
            }

          }).catch(error => {
            callback(error)
          })
        } else {
          callback(new Error('请输入验证码'))
        }

      }
      return {
        registerForm: {
          username: '',
          password: '',
          verificationCode: ''
        },
        registerRules: {
          username: [{required: true, trigger: 'blur', validator: validatePhoneNo}],
          password: [{required: true, trigger: 'blur', validator: validatePass}],
          verificationCode: [{required: true, trigger: 'blur', validator: validateCode}]
        },
        loading: false,
        pwdType: 'password',
        remainingTime: 60,
        totalTime: 60,
        subInterval: null,
        getCode_btn: '获取验证码',
        isDisable: false
      }
    },
    methods: {
      showPwd() {
        if (this.pwdType === 'password') {
          this.pwdType = ''
        } else {
          this.pwdType = 'password'
        }
      },
      handleRegister() {
        let self = this
        this.$refs.registerForm.validate(valid => {
          if (valid) {
            self.loading = true
            // self.$store.dispatch('Register', {
            changePassword({
                username: self.registerForm.username,
                password: self.registerForm.password,
                code: self.registerForm.verificationCode,
              }).then(() => {
              self.loading = false
              this.$message({
                message: '密码重置成功',
                type: 'success'
              });
              self.$router.push({ path: '/login' })
            }).catch(() => {
              self.loading = false
            })
          } else {
            this.$message({
              message: '提交失败',
              type: 'error'
            });
            return false
          }
        })
      },
      /**
       * 发送手机验证码
       * @param name
       */
      sendSmsCode(name) {
        this.$refs[name].validateField('username', (err) => {
          if (!err) {
            this.subInterval = setInterval(this.subTime, 1000)
            this.isDisable = true
            postModifyPasswordCode({
              phoneNumber: this.registerForm.username
            }).then(() => {
              this.$message({
                message: '验证码发送成功',
                type: 'success'
              });
            }).catch(() => {
              this.totalTime = 0
            })
          }
        })
      },
      subTime: function () {
        let totalTime = parseInt(this.totalTime)
        if (totalTime <= 1) {
          this.totalTime = this.remainingTime
          clearInterval(this.subInterval)
          this.subInterval = null
          this.getCode_btn = '获取验证码'
          this.isDisable = false
        } else {
          this.getCode_btn = '重新获取(' + (totalTime - 1) + ')s'
          this.totalTime = totalTime - 1
        }
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss">
  $bg: #2d3a4b;
  $light_gray: #eee;

  /* reset element-ui css */
  .register-container {
    .el-input {
      display: inline-block;
      height: 47px;
      width: 85%;
      input {
        background: transparent;
        border: 0px;
        -webkit-appearance: none;
        border-radius: 0px;
        padding: 12px 5px 12px 15px;
        color: $light_gray;
        height: 47px;
        &:-webkit-autofill {
          -webkit-box-shadow: 0 0 0px 1000px $bg inset !important;
          -webkit-text-fill-color: #fff !important;
        }
      }
    }
    .el-form-item {
      border: 1px solid rgba(255, 255, 255, 0.1);
      background: rgba(0, 0, 0, 0.1);
      border-radius: 5px;
      color: #454545;
      .el-input.is-disabled .el-input__inner {
        background-color: #293443;
      }
    }
  }

</style>

<style rel="stylesheet/scss" lang="scss" scoped>
  $bg: #2d3a4b;
  $dark_gray: #889aa4;
  $light_gray: #eee;
  .register-container {
    position: fixed;
    height: 100%;
    width: 100%;
    background-color: $bg;
    .register-form {
      position: absolute;
      left: 0;
      right: 0;
      width: 520px;
      padding: 35px 35px 15px 35px;
      margin: 120px auto;
    }
    .tips {
      font-size: 14px;
      color: #fff;
      text-align: right;
      margin-bottom: 10px;
    }
    .svg-container {
      padding: 6px 5px 6px 15px;
      color: $dark_gray;
      vertical-align: middle;
      width: 30px;
      display: inline-block;
      &_register {
        font-size: 20px;
      }
    }
    .title {
      font-size: 26px;
      font-weight: 400;
      color: $light_gray;
      margin: 0px auto 40px auto;
      text-align: center;
      font-weight: bold;
    }
    .show-pwd {
      position: absolute;
      right: 10px;
      top: 7px;
      font-size: 16px;
      color: $dark_gray;
      cursor: pointer;
      user-select: none;
    }
    .code {
      width: 70%;
      display: inline-block;
    }
    .get-code {
      height: 50px;
      width: 126px;
    }
    .get-code:hover, .get-code:active, .get-code:focus {
      color: #606266;
    }
    .sign-up {
      width: 100%;
    }

  }
</style>



// WEBPACK FOOTER //
// changePassword.vue?6ff76512